import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "@/components/ui/tooltip";
import { RefreshCw } from "lucide-react";

/**
 * Small "Synced" pill shown next to a field's label when editing a dealer
 * flagged management_migrated_to_ddm=true and this field is one of the
 * fields kept in sync from the feed for such dealers (see
 * GET /api/dealers/ddm-synced-fields, backed by models.DDM_SYNCED_FIELDS) —
 * warns the user that any edit here won't stick past the next import.
 *
 * Unlike FeedPathTag, this is visible to every user editing the field
 * (dealer owners included), not just SYSTEM_ADMIN.
 */
export function SyncFieldBadge({ path, editing, ddmMigrated, syncedFields, testId }) {
  if (!editing || !ddmMigrated || !path || !syncedFields?.includes(path)) return null;

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>
          <span
            data-testid={testId || "sync-field-badge"}
            className="inline-flex shrink-0 items-center gap-0.5 rounded-full bg-amber-500/15 px-1.5 py-0.5 text-[10px] font-medium uppercase tracking-wide text-amber-600 dark:text-amber-400"
          >
            <RefreshCw className="h-2.5 w-2.5" />
            Synced
          </span>
        </TooltipTrigger>
        <TooltipContent className="max-w-xs text-xs">
          This field is overwritten by the next dealer feed import.
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
